// extracted by mini-css-extract-plugin
export var auth_link = "styles-module--auth_link--32672";
export var container = "styles-module--container--fa872";
export var left_side = "styles-module--left_side--9c47d";
export var outer_container = "styles-module--outer_container--1eeb4";
export var right_side = "styles-module--right_side--0bdca";